import { type FC } from 'react';

import { Picture } from '@/components/ui/Picture/Picture';

import styles from './styles.module.scss';

import starsPng from '/img/patterns/stars.png';
import starsWebp from '/img/patterns/stars.webp';

const DailyRewardBackground: FC = () => {
  return (
    <div className="absolute top-0 left-0 w-full h-[17.375rem] -z-10">
      <div className={styles.gradient1} />
      <div className={styles.gradient2} />
      <div className={styles.gradient1} />
      <div className={styles.gradient3} />
      <div className={styles.whiteGradient} />
      <Picture
        className={styles.mask}
        img={starsPng}
        webp={starsWebp}
        alt="stars"
      />
    </div>
  );
};

export default DailyRewardBackground;
